import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { propertyManagementIncomeAPI } from '../../services/api';
import ErrorModal from '../Common/ErrorModal';
import './PropertyManagementIncomeCreate.css';

const PropertyManagementIncomeView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      const response = await propertyManagementIncomeAPI.getById(id);
      setItem(response.data);
    } catch (err) {
      setErrorMessage(t('propertyManagementIncome.view.messages.loadError'));
      setShowErrorModal(true);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="page-container">
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">{t('common.loading')}</span>
          </div>
        </div>
      </div>
    );
  }

  if (!item) {
    return (
      <div className="page-container">
        <div className="text-center py-5">
          <p>{t('propertyManagementIncome.view.messages.notFound')}</p>
          <button className="btn btn-primary" onClick={() => navigate('/property-management-income')}>
            {t('propertyManagementIncome.view.backToList')}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div style={{ display: 'flex', gap: '1rem' }}>
          <button className="btn btn-primary" onClick={() => navigate(`/property-management-income/edit/${id}`)}>
            <i className="fas fa-edit"></i> {t('propertyManagementIncome.view.edit')}
          </button>
          <button className="btn-back" onClick={() => navigate('/property-management-income')}>
            <i className="fas fa-arrow-left"></i> {t('propertyManagementIncome.view.backToList')}
          </button>
        </div>

      <div className="form-container">
        <div className="view-details" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '1.5rem' }}>
          <div className="form-group">
            <label className="form-label">
              <i className="fas fa-calendar"></i> {t('propertyManagementIncome.view.fields.date')}
            </label>
            <div className="detail-value" style={{ padding: '0.75rem', background: '#f8f9fa', borderRadius: '6px', marginTop: '0.5rem' }}>
              {item.date ? new Date(item.date).toLocaleDateString() : '-'}
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">
              <i className="fas fa-building"></i> {t('propertyManagementIncome.view.fields.propertyName')}
            </label>
            <div className="detail-value" style={{ padding: '0.75rem', background: '#f8f9fa', borderRadius: '6px', marginTop: '0.5rem' }}>
              {item.property?.nameEng || item.property?.nameAr || '-'}
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">
              <i className="fas fa-dollar-sign"></i> {t('propertyManagementIncome.view.fields.totalUnitIncome')}
            </label>
            <div className="detail-value" style={{ padding: '0.75rem', background: '#f8f9fa', borderRadius: '6px', marginTop: '0.5rem' }}>
              {item.totalUnitIncome?.toFixed(2) || '0.00'}
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">
              <i className="fas fa-percent"></i> {t('propertyManagementIncome.view.fields.type')}
            </label>
            <div className="detail-value" style={{ padding: '0.75rem', background: '#f8f9fa', borderRadius: '6px', marginTop: '0.5rem' }}>
              {item.isPercentage ? t('propertyManagementIncome.list.type.percentage') : t('propertyManagementIncome.list.type.fixed')}
            </div>
          </div>

          {item.isPercentage && item.percentageValue && (
            <div className="form-group">
              <label className="form-label">
                <i className="fas fa-percent"></i> {t('propertyManagementIncome.view.fields.percentageValue')}
              </label>
              <div className="detail-value" style={{ padding: '0.75rem', background: '#f8f9fa', borderRadius: '6px', marginTop: '0.5rem' }}>
                {item.percentageValue}%
              </div>
            </div>
          )}

          {item.notes && (
            <div className="form-group">
              <label className="form-label">
                <i className="fas fa-sticky-note"></i> {t('propertyManagementIncome.view.fields.notes')}
              </label>
              <div className="detail-value" style={{ padding: '0.75rem', background: '#f8f9fa', borderRadius: '6px', marginTop: '0.5rem' }}>
                {item.notes}
              </div>
            </div>
          )}

          <div className="form-group">
            <label className="form-label">
              <i className="fas fa-clock"></i> {t('propertyManagementIncome.view.fields.createdAt')}
            </label>
            <div className="detail-value" style={{ padding: '0.75rem', background: '#f8f9fa', borderRadius: '6px', marginTop: '0.5rem' }}>
              {item.createdAt ? new Date(item.createdAt).toLocaleString() : '-'}
            </div>
          </div>
        </div>
      </div>

      <ErrorModal
        show={showErrorModal}
        message={errorMessage}
        onClose={() => setShowErrorModal(false)}
      />
    </div>
  );
};

export default PropertyManagementIncomeView;


